















import { Component, Vue } from 'vue-property-decorator';
import PuzzleCalculatorPad from './PuzzleCalculatorPad.vue';
import PuzzleCalculatorOutput from './PuzzleCalculatorOutput.vue';

@Component<PuzzleCalculator>({
  components: { PuzzleCalculatorPad, PuzzleCalculatorOutput },
})
export default class PuzzleCalculator extends Vue {
  padValue: string = '';

  $refs!: {
    output: PuzzleCalculatorOutput;
    pad: PuzzleCalculatorPad;
  };

  focusPadDisplay() {
    this.$refs.pad.$refs.display.focus();
  }
  focuseOutput() {
    this.$refs.output.$refs.output.focus();
    const input = this.$refs.output.$refs.output.$el.querySelector('input');
    if (!input) {
      return;
    }
    input.setSelectionRange(0, input.value.length);
  }
  onKeyup(e: KeyboardEvent) {
    if (e.target !== document.body) {
      return;
    }
    if (/^[0-9+\-*]*$/.test(e.key)) {
      e.preventDefault()
      this.padValue += e.key;
    }
    if (e.key.toLowerCase() === 'c') {
      e.preventDefault()
      this.$refs.pad.clear();
    }
    if (e.key === 'Enter' || e.key === '=') {
      e.preventDefault()
      this.focuseOutput();
    }
    if (e.key === 'Delete' || e.key === 'Backspace') {
      e.preventDefault()
      this.$refs.pad.onBackspace();
    }
  }
  mounted() {
    document.addEventListener('keyup', this.onKeyup.bind(this));
  }
}
